/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <path
    fill="currentColor"
    fillRule="evenodd"
    d="M24 11c0 .622-.0869 1.225-.25 1.7991A2.99 2.99 0 0 1 24 14v7c0 1.6569-1.3431 3-3 3H10c-1.6569 0-3-1.3431-3-3v-3c-3.866 0-7-2.6863-7-6 0-2.0435 1.1919-3.8484 3.0122-4.9318C3.236 3.127 6.5028 0 10.5 0c2.8884 0 5.3955 1.6328 6.6485 4.0258C20.987 4.3326 24 7.338 24 11Zm-8.1803-6.2784.384.7335.8253.066C20.1821 5.773 22.5 8.211 22.5 11c0 .1317-.0052.2626-.0154.3925A2.9861 2.9861 0 0 0 21 11H10c-1.6569 0-3 1.3431-3 3v2.5c-3.2628 0-5.5-2.2233-5.5-4.5 0-1.4239.8296-2.78 2.2794-3.6429l.6852-.4078.0452-.7961C4.6888 4.0016 7.3028 1.5 10.5 1.5c2.3086 0 4.3153 1.3035 5.3197 3.2216ZM11.5 14.75a.75.75 0 0 0 0 1.5h8a.75.75 0 0 0 0-1.5h-8ZM10.75 19a.75.75 0 0 1 .75-.75h4a.75.75 0 0 1 0 1.5h-4a.75.75 0 0 1-.75-.75Z"
    clipRule="evenodd"
  />,
  'MenuDevopsFilled'
);
